/** Tokens visuais — listagem de pedidos (marca TNV) */
export const PEDIDOS_ACCENT = "#F96030";

export const pedidosToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${PEDIDOS_ACCENT}`,
};
